import React from 'react';

import { MCButton, SelectField, TextField, AutoCompleteField } from 'src/components/basic';
import { DateSelects } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { addressObject, lang, objectToSelectList } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

import moment from 'moment';
import { AvatarImages } from 'src/components/user/components';
import { EmailPhoneSection, FormRow } from '../Form';
import { AlertBox } from '../alert';

const apiStateId = 'updatePatient';

class PatientInput extends BaseComponent {
  componentDidMount() {
    const { model } = this.props;
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    const { model } = this.props;
    model.unsubscribe(this.subscription);
  }

  render() {
    const {
      emailReadonly = false,
      phoneReadonly = false,
      imagesEnable = false,
      model
    } = this.props;
    const { handleChangeProfile, handleBlur } = model;
    const { invalid, ...createState } = model.getApiState(apiStateId);

    if (createState.error === 'URLNAME_TAKEN') {
      invalid['username'] = createState.errorMessage;
    }

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
    }
    const address = addressObject(model.state);

    return (
      <>
        <AvatarImages
          avatar={model.input('avatar')}
          images={model.input('images')}
          imagesEnable={imagesEnable}
          invalid={{}}
          onAvatarChange={(v) => {
            model.resetApiState(apiStateId);
            model.handleChangeAvatar(v);
          }}
          onImagesChange={(v) => {
            model.resetApiState(apiStateId);
            handleChangeProfile('images', v);
          }}
        />
        {invalid?.avatar && (
          <AlertBox
            message={invalid?.avatar}
            onClose={() => {
              model.setInvalidApi(apiStateId, { ...invalid, avatar: null });
            }}
          />
        )}
        <div className={'mc-value-620'}>{lang.t('Customer information')}</div>
        <div className={'mc-flex-20-col'}>
          <FormRow addColspan={1}>
            <TextField
              template={6}
              label={'Username'}
              name={'username'}
              value={model.input('username')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <FormRow>
            <TextField
              template={6}
              label={'First Name'}
              name={'firstName'}
              value={model.input('firstName')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
            <TextField
              template={6}
              label={'Last Name'}
              name={'lastName'}
              value={model.input('lastName')}
              onChange={handleChangeProfile}
              onBlur={handleBlur}
              invalid={invalid}
            />
          </FormRow>
          <EmailPhoneSection
            defaultCountryName={model.state.tempCountryAddress}
            emailReadonly={emailReadonly}
            phoneReadonly={phoneReadonly}
            email={model.input('email')}
            handleChangeProfile={handleChangeProfile}
            handleBlur={handleBlur}
            navigate={this.navigate}
            phoneNumber={model.input('phoneNumber').toString()}
          />

          <div className={'mc-flex-20 mc-flex-start'}>
            <div className={'mc-flex-col mc-grow'}>
              <div className={'mc-label-418'}>{lang.t('Birthday')}</div>
              <FormRow>
                <DateSelects
                  close={false}
                  className={'mc-flex-20 mc-user-birthday'}
                  template={'6'}
                  minDate={moment().startOf('year').year(1900)}
                  maxDate={moment().add({ years: -14 }).endOf('year')}
                  onChange={(n, v) => handleChangeProfile(n, v)}
                  invalid={invalid}
                  name={'birthday'}
                  date={model.input('birthday')}
                />
              </FormRow>

              {invalid['birthday'] && <p className='mc-form-invalid-text'>{invalid['birthday']}</p>}
            </div>
          </div>
          <FormRow addColspan={1}>
            <SelectField
              template={6}
              width={'100%'}
              options={objectToSelectList(LANG_CONST.constants.gender)}
              label={LANG_CONST.gender}
              isSearchable={false}
              name={'gender'}
              value={model.input('gender')}
              onChange={handleChangeProfile}
              invalid={invalid}
            />
          </FormRow>
          <div className={'mc-value-620'}>{lang.t(LANG_CONST.your_address)}</div>
          <div className={'mc-flex-20-col'}>
            <FormRow>
              <TextField
                template={6}
                label={'Address line'}
                name={'address'}
                placeholder={''}
                value={model.input('address')}
                onChange={handleChangeProfile}
                onBlur={handleBlur}
                invalid={invalid}
              />
            </FormRow>
            <FormRow>
              <AutoCompleteField
                template={6}
                label={'Country'}
                name={'countryAddress'}
                value={model.input('countryAddress')}
                onChange={(n, v) => {
                  if (model.input('countryAddress') !== v) {
                    handleChangeProfile(n, v);
                    handleChangeProfile('stateAddress', '');
                    handleChangeProfile('cityAddress', '');
                  }
                }}
                autocompleteApi='country'
                autocompleteParams={{
                  limit: 300
                }}
                invalid={invalid}
              />
              <AutoCompleteField
                template={6}
                label={'State'}
                name={'stateAddress'}
                value={model.input('stateAddress')}
                onChange={(n, v) => {
                  handleChangeProfile(n, v);
                  handleChangeProfile('cityAddress', '');
                }}
                invalid={invalid}
                autocompleteParams={{
                  countryCode: address.countryCode,
                  limit: 100
                }}
                autocompleteApi='state'
              />
              <AutoCompleteField
                template={6}
                label={'City'}
                name={'cityAddress'}
                value={model.input('cityAddress')}
                onChange={(n, v) => {
                  handleChangeProfile(n, v);
                }}
                invalid={invalid}
                autocompleteApi='city'
                autocompleteParams={{
                  countryCode: address.countryCode,
                  stateCode: address.stateCode,
                  limit: 20
                }}
              />
            </FormRow>
            <FormRow addColspan={2}>
              <TextField
                template={6}
                label={'Postal code'}
                name={'zipcode'}
                value={model.input('zipcode')}
                onChange={handleChangeProfile}
                onBlur={handleBlur}
                invalid={invalid}
              />
            </FormRow>
          </div>
          <div className={'mc-flex-20'}>
            <MCButton
              label={LANG_CONST.buttons.delete_account}
              medium
              radius
              senary
              light
              onClick={() => model.emit('deleteAccount')}
            />
          </div>
        </div>
      </>
    );
  }
}

export default PatientInput;
